import { render, staticRenderFns } from "./prestamoAdd.vue?vue&type=template&id=66e1d684"
import script from "./prestamoAdd.vue?vue&type=script&lang=js"
export * from "./prestamoAdd.vue?vue&type=script&lang=js"
import style0 from "./prestamoAdd.vue?vue&type=style&index=0&id=66e1d684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports